import React from 'react';
export const MaskedLink = ({ url, target = '_blank', children, ...props }) => (React.createElement("a", { onClick: () => {
        window.open(url, target);
    }, style: { cursor: 'pointer' }, rel: "noopener noreferrer nofollow", ...props }, children));
